/**
 * @providesModule PhoneVerify
 *
 */

import React from 'react';

import {_m} from 'INTL';
import AWSManager from 'AWSManager';
import {
  PHONE_VERIFICATION_DEPOSIT_EXIT,
  PHONE_VERIFICATION_CASH_PLAY_EXIT,
  PHONE_VERIFICATION_MENU_EXIT,
  PHONE_VERIFICATION_DEPOSIT_VIEW,
  PHONE_VERIFICATION_CASH_PLAY_VIEW,
  PHONE_VERIFICATION_MENU_VIEW,
  PHONE_VERIFICATION_DEPOSIT_SEND,
  PHONE_VERIFICATION_CASH_PLAY_SEND,
  PHONE_VERIFICATION_MENU_SEND,
  PHONE_VERIFICATION_DEPOSIT_RESEND,
  PHONE_VERIFICATION_CASH_PLAY_RESEND,
  PHONE_VERIFICATION_MENU_RESEND,
  PHONE_VERIFICATION_DEPOSIT_SUCCESS,
  PHONE_VERIFICATION_MENU_SUCCESS,
  PHONE_VERIFICATION_CASH_PLAY_SUCCESS,
  PLAYER_CHAT_PHONE_VERIFY_SUBMIT_API,
  PLAYER_CHAT_PHONE_VERIFY_SEND,
  PLAYER_CHAT_PHONE_VERIFY_RESEND,
} from 'AWSConstants';
import ClientPropertyConstants from 'ClientPropertyConstants';
import CurrentUserStore from 'CurrentUserStore';
import GDPRCheckbox from 'GDPRCheckbox';
import GlobalEventEmitter from 'GlobalEventEmitter';
import Label from 'Label';
import LinearGradient from 'react-native-linear-gradient';
import LoadingIndicator from 'LoadingIndicator';
import ModalNavigationController from 'ModalNavigationController';
import NetClient from 'NetClient';
import Optional from 'Optional';
import PhoneInput from 'PhoneInput';
import PropTypes from 'prop-types';
import PushButton from 'PushButton';
import RESTStore from 'RESTStore';
import Sizes from 'Sizes';
import SkillzImage from 'SkillzImage';
import SkillzModule from 'SkillzModule';
import SkillzStyle from 'SkillzStyle';
import SKZConstants from 'SKZConstants';
import SKZPersonalInfo from 'SKZPersonalInfo';
import StaticWarningModal from 'StaticWarningModal';
import styles from 'PhoneVerifyStyle';

import {
  Alert,
  KeyboardAvoidingView,
  Keyboard,
  NativeModules,
  Platform,
  ScrollView,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

const {btnGradientOne, viewCornerRadiusPrimary} = SkillzStyle.fullStyles;

const SkillzAPIManager = NativeModules.SKZAPIManager;
export const pathFromTypes = {
  cashPlay: 'Cash_Play',
  deposit: 'Deposit',
  menu: 'Menu',
};
export const getHeaderCopyDefault = (): Object => ({
  body: _m('In order to play for cash, your phone number must be verified.'),
  header: _m('Enable Cash Play'),
});

export default class PhoneVerify extends React.Component {
  static propTypes = {
    onDone: PropTypes.func.isRequired,
    userPersonalInfo: PropTypes.object,
    headerCopyOverride: PropTypes.object,
    pathFrom: PropTypes.oneOf(Object.values(pathFromTypes)),
  };

  _fetchCountry(): Promise<Object> {
    const retryMode =
      Platform.OS == 'android' ? true : NativeModules.SKZAPIManager.OnError.failSilently;
    NetClient.getURL('/location/v1/countries', null, retryMode)
      .then((country) => {
        this.setState({
          country: country.country_code.toLowerCase(),
          countryValue: PhoneInput.getCountryCode(country),
        });
      })
      .catch((error: any) => {
        console.debug('PhoneVerify: failed to fetch country');
      });
  }
  constructor(props: Object) {
    super(props);

    const hasPhone = this.props.userPersonalInfo && this.props.userPersonalInfo.phone_number;
    const country = 'us';
    this.state = {
      userPhone: hasPhone ? this.props.userPersonalInfo.phone_number : '',
      verifyCode: '',
      isConfirmationSent: false,
      scrollViewMinHeight: 10,
      clientProps: this._getClientProperties(),
      country: country,
      shouldRender: Platform.OS != 'android',
      userInfo: null,
      shouldShowModal: false,
      phoneModalMessage: '',
      phoneModalTitle: '',
      showCountryList: false,
    };

    this.closePress = this._onClosePressed.bind(this);

    this.shouldCloseVerificationScreen = false;
    this.didSucceed = false;
  }

  componentDidMount() {
    this._fetchUser();
    this._fetchCountry();
    if (Platform.OS == 'ios') {
      SkillzModule.setEnabledKeyboardManager(true);
    } else {
      this._setupScreen();
    }
    this._onViewAwsEvent();
  }

  componentWillUnmount() {
    if (Platform.OS == 'ios') {
      SkillzModule.setEnabledKeyboardManager(false);
    }
    this.props.onDone(this.didSucceed, this._phoneInput?.getValue());
  }
  _onViewAwsEvent() {
    switch (this.props.pathFrom) {
      case pathFromTypes.deposit:
        AWSManager.trackEvent(PHONE_VERIFICATION_DEPOSIT_VIEW);
        break;
      case pathFromTypes.menu:
        AWSManager.trackEvent(PHONE_VERIFICATION_MENU_VIEW);
        break;
      case pathFromTypes.cashPlay:
        AWSManager.trackEvent(PHONE_VERIFICATION_CASH_PLAY_VIEW);
        break;
      default:
        break;
    }
  }

  _fetchUser() {
    CurrentUserStore.fetchUser(true)
      .then((user: unknown) => {
        this.setState({
          userInfo: user,
        });
      })
      .catch((error: unknown) => {
        console.warn('PhoneVerify: error fetching user info', error);
      });
  }

  _setupScreen() {
    setTimeout(() => {
      this.setState({
        shouldRender: true,
      });
    }, SKZConstants.MS_PER_SEC);
  }

  _onNumberTextInput(text: string) {
    this.setState({
      buttonEnabled: this._phoneInput.isValidNumber(),
    });
  }

  _onVerifyCodeInput(text: string) {
    this.setState({
      verifyCode: text,
    });
  }
  _onSendAWS() {
    AWSManager.trackEvent(PLAYER_CHAT_PHONE_VERIFY_SEND);
    switch (this.props.pathFrom) {
      case pathFromTypes.deposit:
        AWSManager.trackEvent(PHONE_VERIFICATION_DEPOSIT_SEND);
        break;
      case pathFromTypes.menu:
        AWSManager.trackEvent(PHONE_VERIFICATION_MENU_SEND);
        break;
      case pathFromTypes.cashPlay:
        AWSManager.trackEvent(PHONE_VERIFICATION_CASH_PLAY_SEND);
        break;
      default:
        break;
    }
  }

  _onReSendAWS() {
    AWSManager.trackEvent(PLAYER_CHAT_PHONE_VERIFY_RESEND);
    switch (this.props.pathFrom) {
      case pathFromTypes.deposit:
        AWSManager.trackEvent(PHONE_VERIFICATION_DEPOSIT_RESEND);
        break;
      case pathFromTypes.menu:
        AWSManager.trackEvent(PHONE_VERIFICATION_MENU_RESEND);
        break;
      case pathFromTypes.cashPlay:
        AWSManager.trackEvent(PHONE_VERIFICATION_CASH_PLAY_RESEND);
        break;
      default:
        break;
    }
  }

  _onSucessAWS() {
    AWSManager.trackEvent(PLAYER_CHAT_PHONE_VERIFY_SUBMIT_API, {didSucceed: 'Yes'});
    switch (this.props.pathFrom) {
      case pathFromTypes.deposit:
        AWSManager.trackEvent(PHONE_VERIFICATION_DEPOSIT_SUCCESS);
        break;
      case pathFromTypes.menu:
        AWSManager.trackEvent(PHONE_VERIFICATION_MENU_SUCCESS);
        break;
      case pathFromTypes.cashPlay:
        AWSManager.trackEvent(PHONE_VERIFICATION_CASH_PLAY_SUCCESS);
        break;
      default:
        break;
    }
  }

  _onSendPressed() {
    Keyboard.dismiss();
    LoadingIndicator.show();
    this.state.isConfirmationSent ? this._onReSendAWS() : this._onSendAWS();
    const phone = this._phoneInput.getValue();
    if (!this._phoneInput.isValidNumber()) {
      LoadingIndicator.hide();
      Alert.alert('Invalid phone number', 'Please input a valid phone number.');
    } else {
      CurrentUserStore.fetchUser(true)
        .then((user: Object) => {
          const url = 'users/' + user.id + '/phone/verification_tokens';
          const patch = {phone: phone};
          NetClient.patchURL(
            url,
            patch,
            SkillzAPIManager.OnError.failSilently,
            (error: unknown, payload: unknown) => {
              LoadingIndicator.hide();
              const sendToken = true;
              const apiAWSEvent = this.state.isConfirmationSent
                ? 'PLAYER_CHAT_PHONE_VERIFY_RESEND_API'
                : 'PLAYER_CHAT_PHONE_VERIFY_SEND_API';
              if (payload) {
                AWSManager.trackEvent(apiAWSEvent, {didSucceed: 'Yes'});
                this._onPhoneNumberSaved();
                this._displayStatusMessage(false, sendToken);
              } else {
                AWSManager.trackEvent(apiAWSEvent, {didSucceed: 'No'});
                this._displayStatusMessage(true, sendToken);
              }
            }
          );
        })
        .catch((error: unknown) => {
          // this should never happen
        });
    }
  }

  _onPhoneNumberSaved() {
    const phoneNumber = this._phoneInput.getValue();
    const newUserPersonalPhoneNumber = new SKZPersonalInfo();
    newUserPersonalPhoneNumber.phone_number = phoneNumber;
    CurrentUserStore.updateUserPersonalInfo(newUserPersonalPhoneNumber)
      .then(() => {
        // Silently saves the phone number
      })
      .catch((alertError: unknown) => {
        console.error('Error in saving phone number:', alertError);
      });
  }

  _onSubmitPressed() {
    LoadingIndicator.show();
    AWSManager.trackEvent('PLAYER_CHAT_PHONE_VERIFY_SUBMIT');
    const code = this.state.verifyCode;
    const patch = {token: code};
    CurrentUserStore.fetchUser(true)
      .then((user: Object) => {
        this._saveCheckboxPreference();
        const url = 'users/' + user.id + '/phone/verify';
        NetClient.patchURL(
          url,
          patch,
          SkillzAPIManager.OnError.failSilently,
          (error: unknown, payload: unknown) => {
            LoadingIndicator.hide();
            const sendToken = false;
            if (payload) {
              this._onSuccessfulVerify();
              this._onSucessAWS();
              this._displayStatusMessage(false, sendToken);
            } else {
              AWSManager.trackEvent(PLAYER_CHAT_PHONE_VERIFY_SUBMIT_API, {didSucceed: 'No'});
              this._displayStatusMessage(true, sendToken);
            }
          }
        );
      })
      .catch((error: unknown) => {
        // this should never happen
      });
  }

  _displayStatusMessage(error: boolean, sendToken: boolean) {
    this.didSucceed = false;
    if (error) {
      if (sendToken) {
        this.setState({
          shouldShowModal: true,
          phoneModalMessage: _m(
            'This phone number is already associated with another account. Please enter another phone number and try again.'
          ),
          phoneModalTitle: _m('Error'),
        });
      } else {
        this._wipeVerificationCode();
        this.setState({
          shouldShowModal: true,
          phoneModalMessage: _m('The verification code provided is invalid.'),
          phoneModalTitle: _m('Error'),
        });
      }
    } else {
      if (sendToken) {
        this._confirmationSent();
      } else {
        this.shouldCloseVerificationScreen = true;
        this.didSucceed = true;
        this.setState({
          shouldShowModal: true,
          phoneModalMessage: _m('Phone number verified!'),
          phoneModalTitle: _m('Success'),
        });
      }
    }
  }

  _wipeVerificationCode() {
    this.setState({
      verifyCode: '',
    });
  }

  _confirmationSent() {
    this.setState({
      isConfirmationSent: true,
    });
  }

  _onSuccessfulVerify() {
    //this is to update the RESTStore cache
    const updateUserCache = (userId: string) => {
      const url = 'users/' + userId + '/personal';
      RESTStore.getServerResponse(url, null, false, this.updateUserCompletion);
    };
    if (!this.state.userInfo) {
      CurrentUserStore.fetchUser(true)
        .then((user: Object) => {
          updateUserCache(user.id);
        })
        .catch((error) => {
          /* */
        });
    } else {
      updateUserCache(this.state.userInfo.id);
    }
  }

  _saveCheckboxPreference() {
    if (!this._checkbox) {
      console.warn('PhoneVerify: trying to submit email opt in before checkbox exists');
      return;
    }
    const isChecked = this._checkbox.isChecked();
    CurrentUserStore.updateUser({email_opt_in: isChecked})
      .then((result: unknown) => {
        console.debug('PhoneVerify: saved email_opt_in =', isChecked);
      })
      .catch((e: unknown) => {
        console.debug('PhoneVerify: error updating email_opt_in state', e);
      });
  }

  updateUserCompletion(payload: () => {}, error: () => {}) {
    GlobalEventEmitter.emit('UpdateUserSummary');
  }

  _onClosePressed() {
    this._close();
    switch (this.props.pathFrom) {
      case pathFromTypes.deposit:
        AWSManager.trackEvent(PHONE_VERIFICATION_DEPOSIT_EXIT);
        break;
      case pathFromTypes.menu:
        AWSManager.trackEvent(PHONE_VERIFICATION_MENU_EXIT);
        break;
      case pathFromTypes.cashPlay:
        AWSManager.trackEvent(PHONE_VERIFICATION_CASH_PLAY_EXIT);
        break;
      default:
        break;
    }
  }

  _close() {
    if (
      this.props.pathFrom === pathFromTypes.cashPlay &&
      ClientPropertyConstants.getVerifySMSCloseButton()
    ) {
      this.props.onDone(true, this._phoneInput?.getValue());
    } else {
      ModalNavigationController.hideModal();
    }
  }

  _getClientProperties(): Object {
    let imageUrl = ClientPropertyConstants.getPlayerChatPhoneVerifyImage();
    let headerCopy = ClientPropertyConstants.getPlayerChatPhoneVerifyHeaderCopy();
    let messageCopy = ClientPropertyConstants.getPlayerChatPhoneVerifyPromptCopy();
    let phoneInputCopy = ClientPropertyConstants.getPlayerChatPhoneVerifyNumberInput();
    let phoneInputCTACopy = ClientPropertyConstants.getPlayerChatPhoneVerifyNumberCTA();
    let codeInputCopy = ClientPropertyConstants.getPlayerChatPhoneVerifyCodeInput();
    let codeInputCTACopy = ClientPropertyConstants.getPlayerChatPhoneVerifyCodeCTA();

    if (!imageUrl) {
      imageUrl = 'ic_chat_security_icon.png';
    }

    if (!headerCopy) {
      headerCopy = 'Secure Your Account';
    }

    if (!messageCopy) {
      messageCopy =
        'Add your mobile phone number to secure your account and help your friends find you';
    }

    if (!phoneInputCopy) {
      phoneInputCopy = 'Mobile Number';
    }

    if (!phoneInputCTACopy) {
      phoneInputCTACopy = 'Send';
    }

    if (!codeInputCopy) {
      codeInputCopy = 'Enter Verification Code';
    }

    if (!codeInputCTACopy) {
      codeInputCTACopy = 'Save';
    }

    return {
      imageUrl,
      headerCopy,
      messageCopy,
      phoneInputCopy,
      phoneInputCTACopy,
      codeInputCopy,
      codeInputCTACopy,
    };
  }

  _buttonEnabled(): boolean {
    return this._phoneInput && this._phoneInput.isValidNumber();
  }

  _renderChatCloseButton(): React.ReactNode {
    return (
      <TouchableOpacity
        style={styles.closeButtonContainer}
        onPress={this.closePress}
        hitSlop={{top: 10, left: 10, bottom: 10, right: 10}}
        accessibilityLabel={'close_button'}
        accessibilityRole={'button'}
        accessible={true}
      >
        <SkillzImage
          source={'ic_chat_pending_x_skz.png'}
          resizeMode={'contain'}
          color={SkillzStyle.fullStyles.textColorPrimary.color}
          style={styles.closeButton}
        />
      </TouchableOpacity>
    );
  }

  _handleErrorModal = () => {
    this.setState({
      shouldShowModal: false,
    });
    if (this.shouldCloseVerificationScreen) {
      ModalNavigationController.hideModal();
      this.shouldCloseVerificationScreen = false;
    }
  };

  _renderErrorModal(): React.ReactNode {
    return (
      <View style={StyleSheet.absoluteFill}>
        <StaticWarningModal
          message={this.state.phoneModalMessage}
          title={this.state.phoneModalTitle}
          buttonTitleArray={[_m('OK')]}
          callback={this._handleErrorModal}
          messageTextStyling={styles.messageStyle}
        />
      </View>
    );
  }

  _renderMessageLabel(): React.ReactNode {
    return (
      <View
        style={styles.messageContainer}
        accessibilityRole={'none'}
        accessibilityLabel={'phone_verify_message_container'}
        accessible={true}
      >
        <Label style={styles.phoneVerifyLabel}>
          {this.props.headerCopyOverride
            ? this.props.headerCopyOverride.header
            : this.state.clientProps.headerCopy}
        </Label>
        <Label numberOfLines={3} style={styles.requireMessageLabel}>
          {this.props.headerCopyOverride
            ? this.props.headerCopyOverride.body
            : this.state.clientProps.messageCopy}
        </Label>
      </View>
    );
  }

  _renderNumberAndSendButton(): React.ReactNode {
    const placeholderValue = this.props.userPersonalInfo.phone_number
      ? this.props.userPersonalInfo.phone_number
      : '';
    return (
      <View
        style={styles.numberAndSendContainer}
        accessibilityLabel={'phone_number_send_container'}
        accessibilityRole={'none'}
        accessible={false}
      >
        <KeyboardAvoidingView
          behavior={'padding'}
          style={styles.numberInputContainer}
          accessible={false}
        >
          <PhoneInput
            underlineColorAndroid='transparent'
            onChangePhoneNumber={this._onNumberTextInput.bind(this)}
            ref={(phone) => {
              this._phoneInput = phone;
            }}
            keyboardType={'phone-pad'}
            multiline={false}
            textStyle={styles.inputTextStyle}
            placeholder={this.state.clientProps.phoneInputCopy}
            placeholderTextColor={'grey'}
            returnKeyType={'done'}
            style={styles.inputText}
            value={!this.props.userPersonalInfo.phone_number ? this.state.countryValue : ''}
            accessible={false}
            valuePhoneNumber={placeholderValue}
            initialCountry={!this.props.userPersonalInfo.phone_number ? this.state.country : ''}
          />
        </KeyboardAvoidingView>
        <PushButton
          cornerRadius={viewCornerRadiusPrimary.borderRadius}
          style={styles.sendBtnContainer}
          colors={btnGradientOne}
          title={
            this.state.isConfirmationSent ? _m('Resend') : this.state.clientProps.phoneInputCTACopy
          }
          enabled={this._buttonEnabled()}
          onPress={this._onSendPressed.bind(this)}
          textStyle={styles.pushBtnText}
          accessibilityLabel={'send_confirmation_button'}
          accessibilityRole={'button'}
          accessible={true}
        />
      </View>
    );
  }

  _renderVerificationAndSubmitButton(): React.ReactNode {
    if (!this.state.isConfirmationSent) {
      return false;
    }

    const textInput = (
      <TextInput
        underlineColorAndroid='transparent'
        autoCorrect={false}
        autoCompleteType={'off'}
        importantForAutofill={'no'}
        keyboardType={'phone-pad'}
        multiline={false}
        ref={(code) => {
          this._codeInput = code;
        }}
        onChangeText={this._onVerifyCodeInput.bind(this)}
        placeholder={this.state.clientProps.codeInputCopy}
        placeholderTextColor={'grey'}
        value={this.state.verifyCode}
        returnKeyType={'done'}
        style={styles.verificationsInputText}
        accessible={false}
      />
    );
    const pushButton = (
      <PushButton
        cornerRadius={viewCornerRadiusPrimary.borderRadius}
        style={styles.submitBtnContainer}
        colors={btnGradientOne}
        title={this.state.clientProps.codeInputCTACopy}
        enabled={true}
        onPress={this._onSubmitPressed.bind(this, false)}
        textStyle={styles.pushBtnText}
        accessibilityLabel={'submit_verification_button'}
        accessibilityRole={'button'}
        accessible={true}
      />
    );

    const verticleOffsetiOS = Sizes.dynamic({
      tablet: 40,
    });

    if (Platform.OS == 'ios') {
      return (
        <KeyboardAvoidingView
          behavior={'padding'}
          style={styles.submitVerificationContainer}
          keyboardVerticalOffset={verticleOffsetiOS}
          accessible={false}
        >
          <View style={styles.verificationsInputContainer}>{textInput}</View>
          {this._renderGDPRCheckbox()}
          {pushButton}
        </KeyboardAvoidingView>
      );
    } else {
      return (
        <View style={styles.submitVerificationContainer} accessible={false}>
          <KeyboardAvoidingView
            behavior={'padding'}
            style={styles.verificationsInputContainer}
            accessible={false}
          >
            {textInput}
          </KeyboardAvoidingView>
          {this._renderGDPRCheckbox()}
          {pushButton}
        </View>
      );
    }
  }

  _getCheckboxPrecheckState(): Object {
    if (this.state.userInfo && this.state.userInfo.email) {
      return {preChecked: this.state.userInfo.email_opt_in};
    }

    return {};
  }

  _renderGDPRCheckbox(): React.ReactNode {
    const optIn = this._getCheckboxPrecheckState();
    const borderAndCheckColor = StyleSheet.flatten(styles.phoneVerifyLabel).color;

    return (
      <GDPRCheckbox
        additionalStyles={styles.consentBox}
        boxBorderColor={borderAndCheckColor}
        checkMarkColor={borderAndCheckColor}
        ref={(ref: unknown) => {
          this._checkbox = ref;
        }}
        key={optIn}
        {...optIn}
      />
    );
  }

  _scrollAdjustment(width: number, height: number) {
    if (this._scrollView && Sizes.isLandscape()) {
      this._scrollView.scrollTo({y: height * 0.15}); // eslint-disable-line no-magic-numbers
    }
  }

  render(): React.ReactNode {
    if (this.state.shouldRender) {
      return (
        <View style={styles.backgroundContainer}>
          <LinearGradient
            style={styles.backgroundContainer}
            colors={SkillzStyle.gradients.backgroundViewGradient}
          >
            <ScrollView
              style={[styles.scrollViewContainer, {width: Sizes.screenWidth}]}
              contentContainerStyle={[
                styles.scrollViewContentContainer,
                {minHeight: this.state.minHeight},
              ]}
              centerContent={false}
              onLayout={(event: unknown) => {
                this.setState({minHeight: event.nativeEvent.layout.height});
              }}
              accessible={false}
              keyboardShouldPersistTaps={'handled'}
              ref={(scrollView) => {
                this._scrollView = scrollView;
              }}
              onContentSizeChange={(width: number, height: number) => {
                this._scrollAdjustment(width, height);
              }}
            >
              <SkillzImage
                style={styles.shieldImageStyle}
                source={this.state.clientProps.imageUrl}
                resizeMode={'contain'}
                accessibilityLabel={'shield_image'}
                accessibilityRole={'image'}
                accessible={true}
              />
              {this._renderMessageLabel()}
              {this._renderNumberAndSendButton()}
              {this._renderVerificationAndSubmitButton()}
              <Optional test={this.state.shouldShowModal}>{this._renderErrorModal()}</Optional>
            </ScrollView>
            {this._renderChatCloseButton()}
          </LinearGradient>
        </View>
      );
    } else {
      return (
        <View style={styles.backgroundContainer}>
          <ScrollView
            style={[styles.scrollViewContainer, {width: Sizes.screenWidth}]}
            contentContainerStyle={[
              styles.scrollViewContentContainer,
              {minHeight: this.state.minHeight},
            ]}
            centerContent={false}
            onLayout={(event: unknown) => {
              this.setState({minHeight: event.nativeEvent.layout.height});
            }}
            accessible={false}
            keyboardShouldPersistTaps={'handled'}
          />
        </View>
      );
    }
  }
}
